import { UserRole } from './user.model';

/** `data` payload of POST /api/Auth/login and GET /api/Auth/me */
export interface LoginData {
  accessToken?: string; // present on login, absent on /me
  expiresAtUtc?: string;
  userId: string;
  email: string;
  role: string; // server returns capitalised, e.g. "Citizen"
  profileId?: string | null;
  name?: string; // being added to /me data
  fullName?: string; // alt name field, just in case
  phoneNumber?: string; // being added to /me data
  address?: string; // being added to /me data
}

/** Request body for POST /api/Auth/register (matches RegisterRequest schema) */
export interface RegisterRequest {
  email: string;
  username: string;
  password: string;
  confirmPassword: string;
  role: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  title: string;
  gender: string;
  dateOfBirth: string; // ISO date-time
  phoneNumber: string;
  nin: string;
  userType: string;
  state: string;
  city?: string;
  address: string;
  lga: string;
  hasWaiver: boolean;
  waiverSupportingDocument?: string;
  ippisNumber?: string;
}

/** Normalise the server's capitalised role string to our internal UserRole */
export function normaliseRole(role: string): UserRole {
  const r = (role ?? '').toLowerCase();
  if (r === 'citizen' || r === 'registrar' || r === 'judge' || r === 'admin')
    return r;
  return 'citizen';
}
